import { render, staticRenderFns } from "./sidebar.component.vue?vue&type=template&id=661e0dd2&scoped=true"
import script from "./sidebar.component.vue?vue&type=script&lang=js"
export * from "./sidebar.component.vue?vue&type=script&lang=js"
import style0 from "./sidebar.component.vue?vue&type=style&index=0&id=661e0dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661e0dd2",
  null
  
)

export default component.exports